import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import BannerImage from "../../assets/cmc.jpg";
import ViewMoreIcon from "../../assets/right-arrow.svg";
import "./Memory.css";
import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";

function Memory() {
  const [memorys, setMemory] = useState([]);
  const [visible, setVisible] = useState(6);
  const [loading, setLoading] = useState(false);

  const ViewMoreMemory = () => {
    setVisible((prevValue) => prevValue + prevValue);
  };

  useEffect(() => {
    fetchMemory();
  }, []);

  const fetchMemory = (props) => {
    setLoading(true);
    axios
      .get(baseUrl + "/app/memory/")
      .then(async (response) => {
        setMemory(response.data);
        setLoading(false);
        console.log("huyyaMemory: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <section className="memory" id="memory">
      <Container>

        {memorys.length > 0 && (
        <div className="memory-content">
          <div className="section-title pt-5">
            In Loving
            <br />
            memory
          </div>
          {loading ? (
            <div className="loader">
              <Spinner className="loading-color" />
            </div>
          ) : (
            <Row className="memory-row">
              {memorys.slice(0, visible).map((item, index) => {
                return (
                  <Col
                    lg={4}
                    className="memory-image pt-3 d-flex align-items-left flex-column"
                    key={index}
                  >
                    <div class="oval-shape">
                      <img src={item.image} className="w-100" />
                    </div>
                    <div className="memory-name py-3">{item.name}</div>
                  </Col>
                );
              })}
            </Row>
          )}

          {memorys.length > 6 && (
            <div className="view-more">
              <Button
                href="/viewmorememory"
                onClick={ViewMoreMemory}
                className="view-more-btn"
              >
                View More <img src={ViewMoreIcon} />
              </Button>
            </div>
          )}
        </div>
        )}
      </Container>
    </section>
  );
}

export default Memory;
